import React from 'react';

const BookingCancelled = () => {
    return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
            <div className="bg-white rounded-2xl shadow-xl p-12 max-w-lg text-center">
                <div className="text-6xl mb-6">😔</div>
                <h1 className="text-3xl font-bold text-slate-900 mb-4">Plata a fost anulată</h1>
                <p className="text-lg text-slate-600 mb-6">
                    Nu s-a efectuat nicio plată. Poți reprograma oricând dorești.
                </p>

                <a href="/coaching"
                className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold px-8 py-3 rounded-xl transition shadow-md"
                >
                Reprogramează
            </a>
        </div>
        </div>
    );
};

export default BookingCancelled;